import { logger } from '~/utils/logger';
import { useWebSocket } from "~/composables/utils/useWebSocket";

/**
 * Socket.IO Plugin for Nuxt 3
 * Automatically initializes WebSocket connection on app start
 */
export default defineNuxtPlugin(() => {
  // Only run on client-side
  if (process.server) {
    return;
  }

  logger.log("🔌 Initializing WebSocket plugin...");

  // Connect immediately using the composable
  const webSocket = useWebSocket();

  logger.log("🔌 WebSocket composable loaded, connecting...");
  webSocket.connect();

  // Cleanup on window unload
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => {
      logger.log("🔌 Disconnecting WebSocket on page unload...");
      webSocket.disconnect();
    });
  }

  // Optional: Auto-reconnect on page visibility change
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (
        document.visibilityState === "visible" &&
        !webSocket.isConnected.value
      ) {
        logger.log("👁️ Page visible, reconnecting WebSocket...");
        webSocket.connect();
      }
    });
  }
});
